// removed by extract-text-webpack-plugin
module.exports = {"content":"styles__content___-ZJk5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/styles.scss
// module id = 7704
// module chunks = 0